import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const SliderListCardsContainer = styled.div``;

export default withAnimation(SliderListCardsContainer);
